export default {
  namespaced: true,
  simulacrum: {
    title: "Simulacrum",
    simulacrums_title: "Simulacrums",
    new: "New Simulacrum",
    reference_number: "Reference Number",
    select_form: "Select form(s)",
    select_form_place_holder: "Select a form",
    selected_form: "Selected form",
    answer_form: "Start form",
    start_form: "Start form",
    confirm_delete: "Are you sure you want to delete this simulacrum?",
    no_records: "No simulacrums found",
    reassign: "Reassign",
    template: {
      title: "Form Templates",
      question: "Question | Questions",
      options: "Options",
    },
    confirm_cancel: "Are you sure you want to cancel this simulacrum?",
    canceled: "Simulacrum canceled",
  },
};


